export default {
    methods: {
        buildCommandResult(data) {
            return {
                resp_id: data.resp_id || 0,
                resp_command_id: data.resp_command_id || 0,
                resp_dataset_id: data.resp_dataset_id || 0,
                resp_dataset_validation: data.resp_dataset_validation || 0,
                resp_dataset_validation_msg: data.resp_dataset_validation_msg || null,
                resp_status: data.resp_status || 0,
                resp_user_data_status: data.resp_user_data_status || 0,
                resp_user_id: data.resp_user_id || 0,
                created_at: data.created_at || null,
                deleted_at: data.deleted_at || null,
                updated_at: data.updated_at || null,
                resp_type: data.resp_type || 'text',
                resp_quick_reply: data.resp_quick_reply || [], // ignore it
                resp_text: data.resp_text || '',
                resp_fallback_msg: data.resp_fallback_msg || '',
                resp_menu_id: data.resp_menu_id || 0,
                resp_menu_extra_options: data.resp_menu_extra_options || [],
                resp_cart_action: data.resp_cart_action || 'insert',
                resp_cart_title: data.resp_cart_title || 0,
                resp_cart_quantity: data.resp_cart_quantity || 0,
                resp_data_source_id: data.resp_data_source_id || 0,
                resp_data_source_query_string: data.resp_data_source_query_string || '',
                resp_api_url: data.resp_api_url || '',
                resp_api_req_type: data.resp_api_req_type || 'get',
                resp_sub_channel: data.resp_sub_channel || 0,
                resp_api_headers: data.resp_api_headers || '',
                resp_api_pars: data.resp_api_pars || [],
                resp_user_data_pars: data.resp_user_data_pars || [],
                resp_user_data_mode_name: data.resp_user_data_mode_name || '',
                resp_api_resp_type: data.resp_api_resp_type || 'json',
                resp_api_resp_data_field: data.resp_api_resp_data_field || '',
                resp_api_resp_data_type: data.resp_api_resp_data_type || 'single',
                resp_api_resp_data_limit: data.resp_api_resp_data_limit || 3,
                resp_api_resp_via: data.resp_api_resp_via || 'text',
                resp_api_resp_struct: data.resp_api_resp_struct || {
                    title_key: '',
                    title_default_value: '',
                    subtitle_key: '',
                    subtitle_default_value: '',
                    media_key: '',
                    media_default_value: '',
                    item_label_key: '',
                    item_label_default_value: '',
                    item_value_key: '',
                    item_value_default_value: '',
                    buttons: [
                        {
                            item_label_key: '',
                            item_label_default_value: '',
                            item_value_key: '',
                            item_value_default_value: '',
                        },
                    ],
                },
                resp_component_resp_data_type: data.resp_component_resp_data_type || 'single',
                resp_component_resp_data_limit: data.resp_component_resp_data_limit || 3,
                resp_component_resp_via: data.resp_component_resp_via || 'text',
                resp_component_resp_struct: data.resp_component_resp_struct || {
                    title_key: '',
                    title_default_value: '',
                    subtitle_key: '',
                    subtitle_default_value: '',
                    media_key: '',
                    media_default_value: '',
                    item_label_key: '',
                    item_label_default_value: '',
                    item_value_key: '',
                    item_value_default_value: '',
                    buttons: [
                        {
                            item_label_key: '',
                            item_label_default_value: '',
                            item_value_key: '',
                            item_value_default_value: '',
                        },
                    ],
                },
                resp_static_cards_resp_struct: data.resp_static_cards_resp_struct || [],
                resp_location_resp_struct: data.resp_location_resp_struct || [],
                resp_api_extra_resp: data.resp_api_extra_resp || {
                    message: '',
                    options: [],
                },
                resp_action_status: data.resp_action_status || false,
                resp_actions: data.resp_actions || [],
                resp_user_data_dataset_id: data.resp_user_data_dataset_id || 0,
                resp_data_source_resp_data_limit: data.resp_data_source_resp_data_limit || 3,
                resp_data_source_resp_via: data.resp_data_source_resp_via || 'text',
                resp_data_source_resp_struct: data.resp_data_source_resp_struct || {
                    title_key: '',
                    title_default_value: '',
                    subtitle_key: '',
                    subtitle_default_value: '',
                    media_key: '',
                    media_default_value: '',
                    item_label_key: '',
                    item_label_default_value: '',
                    item_value_key: '',
                    item_value_default_value: '',
                    buttons: [
                        {
                            item_label_key: '',
                            item_label_default_value: '',
                            item_value_key: '',
                            item_value_default_value: '',
                        },
                    ],
                },
                resp_component_id: data.resp_component_id || 0,
                resp_dataset: data.resp_dataset || {}, // NEW
            };
        },
    }
};
